import { round } from 'lodash-es';
import { Graphics, Point, settings, Sprite, } from 'pixi.js-legacy';
import Constants from '../constants';
import { TooltipManager, TooltipOptions, TooltipPosition } from '../managers';
import ViewStyle from '../viewStyle';
export class AngleOptions {
    constructor() {
        this.id = '';
        this.direction = Constants.vertical;
        this.startPosition = new Point(0, 0);
        this.endPosition = new Point(0, 0);
        this.mark = '0';
        this.viewStyle = ViewStyle.Diagram;
    }
}
export class Angle extends Sprite {
    constructor(pixiRenderer, options = new AngleOptions()) {
        super();
        this.viewStyle = options.viewStyle;
        this.name = 'Angle';
        this.id = options.id;
        this.tier = options.tier;
        this.mark = options.mark;
        this.direction = options.direction;
        this.startPosition = options.startPosition;
        this.endPosition = options.endPosition;
        if (options.direction === Constants.horizontal) {
            this.width = options.endPosition.x - options.startPosition.x;
            this.height = 6;
            this.anchor.x = 0;
            this.anchor.y = 0.5;
        }
        else {
            this.height = options.endPosition.y - options.startPosition.y;
            this.width = 6;
            this.anchor.x = 0.5;
            this.anchor.y = 0;
        }
        this.position.x = options.startPosition.x;
        this.position.y = options.startPosition.y;
        const graphics = new Graphics();
        const scale = 2;
        const resolution = 10;
        graphics.lineStyle(4 * scale, 0x6e6e6e);
        graphics.moveTo(0, this.height);
        graphics.lineTo(this.width, this.height);
        this.texture = pixiRenderer.generateTexture(graphics, {
            scaleMode: settings.SCALE_MODE,
            resolution: resolution,
        });
        graphics.destroy();
        const tooltipOptions = new TooltipOptions();
        tooltipOptions.text =
            `Angle (${this.mark}) \n` +
                `X: ${round(this.x / Constants.scalingFactor, 3)}, ` +
                `Y: ${round(this.y / Constants.scalingFactor, 3)}\nSection: N/A`;
        tooltipOptions.position =
            this.direction === Constants.horizontal
                ? TooltipPosition.Top
                : TooltipPosition.Right;
        tooltipOptions.tierOffset = this.tier.position;
        TooltipManager.getInstance().addTooltip(this, tooltipOptions);
    }
    diagramMode() {
        this.viewStyle = ViewStyle.Diagram;
    }
    designMode() {
        this.viewStyle = ViewStyle.Design;
    }
}
